import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

export async function fetchTypeVehicles({ commit }, filter) {
    await $http
        .get(`/api/vehiculo-tipos`, {
            params: {
                filter
            }
        })
        .then(response => {
            commit("setTypeVehicles", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function createVehicle({ commit }, data) {
    await $http
        .post(`/api/tercero-vehiculo`, data)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo creado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function updateVehicle({ commit }, data) {
    await $http
        .put(`/api/tercero-vehiculo/${data.id}`, data)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo actualizado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function deleteVehicle({ commit }, id) {
    await $http
        .delete(`/api/tercero-vehiculo/${id}`)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo eliminado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/contact-vehicles/actions.js